import { create } from 'zustand';
import i18n from 'localization/i18nextConf'; // Ensure i18n is initialized

interface LocalizationState {
	activeLanguage: string;
	setActiveLanguage: (language: string) => void;
}

const useLocalizationStore = create<LocalizationState>((set) => ({
	activeLanguage: localStorage.getItem('i18nextLng') ?? 'en', // Initialize with default language 'en'
	setActiveLanguage: (language: string) => {
		i18n.changeLanguage(language); // Change i18n language dynamically
		localStorage.setItem('i18nextLng', language); // Persist language choice
		set({ activeLanguage: language });
	},
}));

export default useLocalizationStore;
